import { render, staticRenderFns } from "./user-classes-list.vue?vue&type=template&id=13083e6e&scoped=true&"
import script from "./user-classes-list.ts?vue&type=script&lang=ts&"
export * from "./user-classes-list.ts?vue&type=script&lang=ts&"
import style0 from "./user-classes-list.scss?vue&type=style&index=0&id=13083e6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13083e6e",
  null
  
)

export default component.exports